module.exports = __webpack_public_path__ + "img/itembg2.108e0047.png";